import { useLayoutEffect } from "preact/hooks"

export function useLayoutClass(name: string) {
	useLayoutEffect(() => {
		document.documentElement.classList.add(name)
		return () => document.documentElement.classList.remove(name)
	}, [name])
}
